/**
 * Single source of truth for API origin. Override with REACT_APP_BACKEND_URL
 * (e.g. http://localhost:8000 in .env.local for local backend).
 */
export const DEFAULT_BACKEND_URL = 'https://soulsathiya-backend.onrender.com';

export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || DEFAULT_BACKEND_URL;
